module.exports = __webpack_public_path__ + "img/four.c25e38ca.png";